import { isProd } from "./global-const";
import { checkMenuAccess } from "src/utils/utils"

export const getHeaderLinks = (accessControl: any): any[] => {

  if (isProd) {
    return [
      { label: "Masters", value: "masters", access: checkMenuAccess(accessControl?.menus, "Masters") },
      {
        label: "Request Approval",
        value: "request-approval",
        access: checkMenuAccess(accessControl?.menus, "RequestApproval"),
      },
      { label: "Transactions", value: "transactions", access: checkMenuAccess(accessControl?.menus, "Transactions") },
      { label: "Reports", value: "reports", access: checkMenuAccess(accessControl?.menus, "Reports") },
      { label: "Feedback", value: "feedback", access: true },
    ];
  } else {
    return [
      { label: "Masters", value: "masters", access: checkMenuAccess(accessControl?.menus, "Masters") },
      {
        label: "Request Approval",
        value: "request-approval",
        access: checkMenuAccess(accessControl?.menus, "RequestApproval"),
      },
      { label: "Transactions", value: "transactions", access: checkMenuAccess(accessControl?.menus, "Transactions") },
      { label: "Reports", value: "reports", access: checkMenuAccess(accessControl?.menus, "Reports") },
      { label: "Feedback", value: "feedback", access: true },
    ];
  }
};

export const getSubHeaderLinks = (accessControl: any) => {
  if (isProd) {
    return [
      { label: "Employees", value: "masters/Employees", access: checkMenuAccess(accessControl?.menus, "Masters/Employees") },
      { label: "Products", value: "masters/Products", access: checkMenuAccess(accessControl?.menus, "Masters/Products") },
      { label: "Counters", value: "masters/Counters", access: checkMenuAccess(accessControl?.menus, "Masters/Counters") },
      { label: "Stockists", value: "masters/Stockists", access: checkMenuAccess(accessControl?.menus, "Masters/Stockists") },
      // { label: "Counters", value: "Counters", roles: accessControl.menus?.MASTERS?.SECONDARY_MENUS.COUNTERS?.ALLOWED_ROLES || ["Any"] },
      {
        label: "Divisions",
        value: "masters/divisions",
        access: checkMenuAccess(accessControl?.menus, "Masters/Divisions")
      },
      {
        label: "Geographic",
        value: "masters/geographic",
        access: checkMenuAccess(accessControl?.menus, "Masters/Geographic")
      },
       // { label: "Invoice", value: "masters/invoice", roles: accessControl.menus?.MASTERS?.SECONDARY_MENUS.INVOICE?.ALLOWED_ROLES || ["Any"] },
    ];
  } else {
    return [
      { label: "Employees", value: "masters/Employees", access: checkMenuAccess(accessControl?.menus, "Masters/Employees") },
      { label: "Products", value: "masters/Products", access: checkMenuAccess(accessControl?.menus, "Masters/Products") },
      { label: "Counters", value: "masters/Counters", access: checkMenuAccess(accessControl?.menus, "Masters/Counters") },
      {
        label: "Divisions",
        value: "masters/Divisions",
        access: checkMenuAccess(accessControl?.menus, "Masters/Divisions")
      },
      { label: "Stockists", value: "masters/Stockists", access: checkMenuAccess(accessControl?.menus, "Masters/Stockists") },
      {
        label: "Geographic",
        value: "masters/geographic",
        access: checkMenuAccess(accessControl?.menus, "Masters/Geographic")
      },
      {
        label: "Company",
        value: "masters/Company",
        access: checkMenuAccess(accessControl?.menus, "Masters/Company")
      },
      // { label: "Invoice", value: "masters/invoice", roles: accessControl.menus?.MASTERS?.SECONDARY_MENUS.INVOICE?.ALLOWED_ROLES || ["Any"] },
    ];
  }
};

export const getSubHeaderLinks2 = (accessControl: any) => {
  if (isProd) {
    return [
      { label: "PRA", value: "request-approval/Pra", access: checkMenuAccess(accessControl?.menus, "RequestApproval/PRA") },
      { label: "CRA", value: "request-approval/Cra", access: checkMenuAccess(accessControl?.menus, "RequestApproval/CRA") },
    ];
  } else {
    return [
      { label: "PRA", value: "request-approval/Pra", access: checkMenuAccess(accessControl?.menus, "RequestApproval/PRA") },
      { label: "CRA", value: "request-approval/Cra", access: checkMenuAccess(accessControl?.menus, "RequestApproval/CRA") },
    ];
  }
};

export const getTransactionsSubHeaderLinks = (accessControl: any) => {
  if (isProd) {
    return [
      { label: "Orders", value: "transactions/orders", access: checkMenuAccess(accessControl?.menus, "Transactions/Orders") },
      { label: "Invoices", value: "transactions/invoice", access: checkMenuAccess(accessControl?.menus, "Transactions/Invoices") },
      { label: "Purchase Order", value: "transactions/purchase-order", access: checkMenuAccess(accessControl?.menus, "Transactions/PurchaseOrder") },
      { label: "Reconciliation", value: "transactions/reconciliation", access: checkMenuAccess(accessControl?.menus, "Transactions/Reconciliation") },
    ];
  } else {
    return [
      { label: "Orders", value: "transactions/orders", access: checkMenuAccess(accessControl?.menus, "Transactions/Orders") },
      { label: "Invoices", value: "transactions/invoice", access: checkMenuAccess(accessControl?.menus, "Transactions/Invoices") },
      { label: "Purchase Order", value: "transactions/purchase-order", access: checkMenuAccess(accessControl?.menus, "Transactions/PurchaseOrder") },
      { label: "Reconciliation", value: "transactions/reconciliation", access: checkMenuAccess(accessControl?.menus, "Transactions/Reconciliation") },

    ];
  }
}

export const getReportsSubHeaderLinks2 = (accessControl: any) => {

  return [
    //M10-13117
    {
      label: "Masters", value: "reports/master", access: checkMenuAccess(accessControl?.menus, "Reports/BoxPackCorona"),
    },
    {
      label: "Request Approval", value: "reports/request-approval", access: checkMenuAccess(accessControl?.menus, "Reports/BoxPackCorona"),
    },
    {
      label: "Transactions", value: "reports/transaction", access: checkMenuAccess(accessControl?.menus, "Reports/BoxPackCorona"),
    },
    {
      label: "Counter", value: "reports/counter", access: checkMenuAccess(accessControl?.menus, "Reports/Counter"),
    },
    //M10-11948
    {
      label: "Feedback", value: "reports/feedback", access: true,
    },
    {
      label: "Stockist Reconciliation", value: "reports/stockist-reconciliation", access: checkMenuAccess(accessControl?.menus, "Reports/StockistReconciliation"),
    },
    { label: "Settlements", value: "reports/settlements", access: checkMenuAccess(accessControl?.menus, "Reports/Settlements") },
    { label: "Operational Metrics", value: "reports/operational-metrics", access: checkMenuAccess(accessControl?.menus, "Reports/OperationalMetrics") }
  ];
};

export const getFeedbackSubHeaderLinks = (accessControl: any) => {
  return [{ label: "", value: "feedback/operational-feedback", access: checkMenuAccess(accessControl?.menus, "Masters") }, ];
}